import * as clone from 'clone';

export class CloneUtils {

    public static deepClone<T>(value: T): T {
        return clone<T>(value);
    }

}
